<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
import store from "@/store";
import { getLocalStorage } from "./utils/storage";
export default {
  created() {
    // window.onload = function() {
    //   // 阻止双击放大
    //   var lastTouchEnd = 0;
    //   document.addEventListener("touchstart", function(event) {
    //     if (event.touches.length > 1) {
    //       event.preventDefault();
    //     }
    //   });
    //   document.addEventListener(
    //     "touchend",
    //     function(event) {
    //       var now = new Date().getTime();
    //       if (now - lastTouchEnd <= 300) {
    //         event.preventDefault();
    //       }
    //       lastTouchEnd = now;
    //     },
    //     false
    //   );

    //   // 阻止双指放大
    //   document.addEventListener("gesturestart", function(event) {
    //     event.preventDefault();
    //   });
    // };
    store.dispatch("GetSystem");
    if (store.getters.token) {
      store.dispatch("RefreshUserInfo");
    }
    if(getLocalStorage("login_token")!=null){
      store.dispatch("SetUser", getLocalStorage("login_token"));
    }
  },
  
  methods:{

  }
};
</script>

<style lang="less">
// @import url("//at.alicdn.com/t/font_690270_8f849h4g1ju.css");
@import url("//at.alicdn.com/t/font_1110362_cjqt23e537.css");

#app {
  @import url("./style/common.less");

  html,
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background: #f3f3f3;
  }

  html {
    font-size: calc(100vw / 7.5);
  }

  body {
    font-size: 14px;
  }

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  #app::-webkit-scrollbar {
    display: none;
  }
}
p,
div,
h1,
h2,
h3 {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
<style>
/* @media screen and (min-width: 750px) {
  html {
    width: 750px;
    margin: 0px auto;
    font-size: 70px !important;
  }
  .van-tabbar--fixed {
    width: 750px !important;
  }
} */
</style>
